module.exports = __webpack_public_path__ + "static/media/image_aboutus_m.8434cf48.png";